<template>
  <div class="image_box" v-loading.fullscreen.lock="showLoading">
    <div class="box_operation first_row">
      <div class="first_row_left">
      <div class="input_box">
        <el-select v-model="imageType" placeholder="请选择" @change="onImageTypeChange">
          <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="input_box">
        <el-select v-model="categoryId" placeholder="请选择分类" clearable @change="selectCategoryChange">
          <el-option-group label="常用分类">
            <el-option
                v-for="item in priorityCategories"
                :key="item.id"
                :label="item.categoryName"
                :value="item.id">
            </el-option>
          </el-option-group>
          <el-option-group label="其他分类">
            <el-option
                v-for="item in normalCategories"
                :key="item.id"
                :label="item.categoryName"
                :value="item.id">
            </el-option>
          </el-option-group>
        </el-select>
      </div>

      <!--            操作列表-->
      <div class="input_box">
        <el-select v-model="pageCount" placeholder="每页数量" @change="onPageCountChange">
          <el-option
              v-for="item in pageNumList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>

      <!--            操作列表-->
      <div class="input_box">
        <!-- 搜索历史：管理员功能，前端本地存储，不增加后端复杂性以免影响APP -->
        <el-autocomplete
            ref="searchAutocomplete"
            v-model="searchName"
            :fetch-suggestions="querySearchHistory"
            :trigger-on-focus="true"
            placeholder="请输入图片名称"
            class="input-with-select"
            clearable
            @clear="refreshSearchHistoryPanel"
            @click.native="onSearchAutocompleteClick"
            @select="onSearchHistorySelect"
            @keyup.enter.native="search(true)">
        </el-autocomplete>
      </div>
      <div class="input_box switch_box">
        <el-switch
          v-model="isStrictSearch"
          active-text="严格匹配"
          @change="onStrictSearchChange">
        </el-switch>
      </div>
      <div class="input_box date_range_box">
        <el-date-picker
            v-model="dateRange"
            type="daterange"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="onDateRangeChange">
        </el-date-picker>
      </div>
      </div>
      <!-- 搜图片表 url 最后一段文件名，走单独接口，不碰原来的名称搜索 -->
      <div class="file_name_search">
        <el-input
            v-model="urlFileName"
            size="mini"
            placeholder="文件名"
            clearable
            @keyup.enter.native="searchByFileName">
        </el-input>
        <el-button type="text" size="mini" @click="searchByFileName">搜索</el-button>
      </div>
    </div>

    <!--    <el-dialog :title="dialogTitle"-->
    <!--               @close="closeDialog"-->
    <!--               top="5vh"-->
    <!--               :visible.sync="showDialogtoo"-->
    <!--               :close-on-click-modal="false"-->
    <!--               width="1200px"-->
    <!--               @opened="dialogOpen"-->
    <!--               :destroy-on-close="true"-->
    <!--               :fullscreen="false">-->
    <!--      <ImageBox @postFrom="postFrom"/>-->
    <!--    </el-dialog>-->
    <div class="box_operation">
      <!--      <div class="btn_box">-->
      <!--        <el-button  type="primary" @click="open">点击查询</el-button>-->
      <!--      </div>-->
      <div class="btn_box">
        <el-button type="warning" @click="search(true)">搜索</el-button>
      </div>
      <div class="btn_box">
        <el-button type="primary" @click="addImage">添加</el-button>
      </div>
      <div class="btn_box">
        <el-button type="success" @click="reset">重置</el-button>
      </div>
      <div class="btn_box">
        <el-button type="danger" @click="getImages()">刷新</el-button>
      </div>
      <div class="btn_box" v-if="!isMaterialCollaborator && viewMode === 'table'">
        <el-button type="info" @click="delImages">批量删除{{ delImageIds.length }}</el-button>
      </div>
      <div class="btn_box">
        <el-button type="warning" plain @click="openTagReplaceDialog">替换标签</el-button>
      </div>
      <div class="btn_box">
        <el-button type="primary" plain @click="saveAllImageTags" :disabled="changedTagCount === 0">
          保存全部标签{{ changedTagCount > 0 ? `(${changedTagCount})` : '' }}
        </el-button>
      </div>
      <div class="btn_box view_mode_box">
        <el-radio-group v-model="viewMode" size="small" @change="onViewModeChange">
          <el-radio-button label="table">表格模式</el-radio-button>
          <el-radio-button label="compact">图片模式</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="data_box">
      <div v-if="viewMode === 'compact'" class="compact-sort-bar">
        <span class="compact-sort-title">排序：</span>
        <span
            v-for="item in compactSortItems"
            :key="item.prop"
            class="compact-sort-item"
            :class="{ 'is-active': getCompactSortOrder(item.prop) }"
            @click="onCompactSortClick(item.prop)">
          {{ item.label }}
          <i v-if="getCompactSortOrder(item.prop) === 'descending'" class="el-icon-caret-bottom"/>
          <i v-else-if="getCompactSortOrder(item.prop) === 'ascending'" class="el-icon-caret-top"/>
        </span>
      </div>
      <el-table
          v-if="viewMode === 'table'"
          ref="multipleTable"
          class="table"
          :data="images"
          style="width: 100%"
          @selection-change="selectAllChange"
          @row-click="toggleSelection"
          :row-class-name="tableRowClassName"
          :default-sort="{ prop: 'time', order: 'descending' }"
          @sort-change="sortChange">
        <el-table-column
            type="selection"
            width="55"
        >
        </el-table-column>
        <el-table-column
            align="center"
            prop="id"
            label="id"
            width="60">
        </el-table-column>
        <el-table-column
            align="center"
            label="预览"
            width="180">
          <template slot-scope="scope">
            <div class="preview_container">
              <a href="javascript:void(0)"
                 @click="handlePreviewClick($event, scope.row)">
                <img 
                  :src="isVideoFile(scope.row.url) ? getVideoSnapshot(scope.row.url) : scope.row.url" 
                  class="preview_image"
                  @error="handleImageError">
              </a>
              <!-- 视频标记 -->
              <div v-if="isVideoFile(scope.row.url)" class="video_mark">
                视频
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="130"
            label="分类">
          <template slot-scope="scope">
            <p>{{
                scope.row.firstCategory && scope.row.secondCategory && scope.row.thirdCategory &&
                scope.row.firstCategory.categoryName + "-" + scope.row.secondCategory.categoryName +
                "-" + scope.row.thirdCategory.categoryName
              }}</p>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="tag"
            label="图片标签"
            width="390">
          <!-- 标签列可排序：管理员功能，前端本地排序，不增加后端复杂性以免影响APP -->
          <template slot-scope="scope">
            <div :data-tag-row-id="scope.row.id" class="image-tag-input-wrap">
              <el-input
                  v-model="scope.row.tag"
                  placeholder="图片标签"
                  :disabled="!canEditToday(scope.row.time)"
                  @keyup.enter.native="canEditToday(scope.row.time) && updateImageTag(scope.row)"
                  @keydown.native="handleTagInputKeydown($event, scope.row)"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="heat"
            label="热度"
            width="80">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="hotness"
            label="新热度"
            width="80">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="recentHotness"
            label="最近7天热度"
            width="140">
        </el-table-column>
        <el-table-column
            align="center"
            prop="time"
            sortable="custom"
            width="180"
            label="上传时间">
        </el-table-column>
        <el-table-column
            align="center"
            prop="updateTime"
            sortable="custom"
            width="180"
            label="更新时间">
        </el-table-column>
        <el-table-column
            align="center"
            label="大小(kb)"
            width="80">
          <template slot-scope="scope">
            <p>{{ (scope.row.size / 1024).toFixed(2) }}</p>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="hasTemplateData"
            sortable="custom"
            label="是否有操作数据"
            width="180">
          <template slot-scope="scope">
            <p>{{ scope.row.hasTemplateData > 1 ? "有(自动模版)" : scope.row.hasTemplateData === 1 ? "有" : "否" }}</p>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="是否加锁"
            width="80">
          <template slot-scope="scope">
            <el-tag
                effect="plain">{{ scope.row.isLock === 13 ? "未审核" : scope.row.isLock === 1 ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            width="250"
            align="center"
            label="操作">
          <template slot-scope="scope">
<!--            <el-button type="success" size="medium" icon="el-icon-view" @click="showImageDetail(scope.row)"></el-button>-->
            <el-button v-if="canEditToday(scope.row.time)" type="primary" size="medium" icon="el-icon-edit" @click="updateImage(scope.row)"></el-button>
            <el-button v-if="canEditToday(scope.row.time)" type="danger" size="medium" icon="el-icon-delete" @click="delImage(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <ImageCompactGrid
          v-if="viewMode === 'compact'"
          ref="compactGrid"
          :images="images"
          :can-edit="canEditToday"
          @tag-enter="updateImageTag"
          @tag-keydown="handleTagInputKeydown"
          @preview-click="handlePreviewClick"
          @edit="updateImage"
          @delete="delImage"/>
      <div class="page">
        <el-pagination
            background
            :page-size="pageCount"
            :page-sizes="pageSizeOptions"
            :current-page="pageNo"
            layout="prev, pager, next, sizes"
            :page-count="pageSum"
            @size-change="onPageCountChange"
            @current-change="changePage">
        </el-pagination>
        <div v-if="showCurrentPageImageCount" class="page-count-tip">
          当前页共 <span class="page-count-tip__num">{{ images.length }}</span> 条图片（不足一页）
        </div>
      </div>
    </div>

    <el-dialog :title="dialogTitle"
               @close="closeDialog"
               top="5vh"
               :visible.sync="showDialog"
               :close-on-click-modal="false"
               width="1200px"
               height="75vh"
               @opened="dialogOpen"
               :destroy-on-close="true"
               :fullscreen="false">
      <!--普通类图片编辑和上传-->
      <ImageEdit v-on:saveStatus="saveStatus" :images="selectImages"
                 :categoryList="categoryList" :is-update="isUpdate" :loadData="loadDialogData"
                 v-if="(imageType===''||imageType==='all')&&!showImageDetailDialog"/>

      <!--搜索、模板类图片编辑和上传-->
      <SearchImageUpload v-on:saveStatus="saveStatus" :images="selectImages"
                         :categoryList="categoryList" :is-update="isUpdate" :loadData="loadDialogData"
                         :imageType="imageType" :image-types="isUpdate ? [] : typeList"
                         v-if="imageType!==''&&imageType!=='all'&&!showImageDetailDialog"/>

      <!--图片详情预览-->
      <ImageDetail v-on:saveStatus="saveStatus" :images="selectImages"
                   :categoryList="categoryList" :is-update="isUpdate" :loadData="loadDialogData"
                   v-show="showImageDetailDialog"/>
    </el-dialog>

    <el-dialog
        title="替换标签"
        :visible.sync="showTagReplaceDialog"
        width="520px"
        :close-on-click-modal="false"
        append-to-body>
      <el-form label-width="100px">
        <el-form-item label="模式">
          <el-radio-group v-model="tagReplaceMode">
            <el-radio label="normal">普通替换</el-radio>
            <el-radio label="regex">正则替换</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="替换范围">
          <el-input
              v-model="tagReplaceRange"
              placeholder="如 1-100 或 1~50"
              @keyup.enter.native="applyTagReplaceOne">
          </el-input>
        </el-form-item>
        <el-form-item :label="tagReplaceMode === 'regex' ? '正则' : '查找'">
          <el-input
              v-model="tagReplaceFrom"
              :placeholder="tagReplaceMode === 'regex' ? '输入正则，如 \\d+ 或 prefix-' : '输入要替换的字符'"
              @keyup.enter.native="applyTagReplaceOne">
          </el-input>
        </el-form-item>
        <el-form-item label="替换为">
          <el-input
              v-model="tagReplaceTo"
              :placeholder="tagReplaceMode === 'regex' ? '支持 $1、$2 等分组引用' : '输入替换后的字符'"
              @keyup.enter.native="applyTagReplaceOne">
          </el-input>
        </el-form-item>
        <el-form-item v-if="tagReplaceMode === 'regex'" label=" ">
          <el-checkbox v-model="tagReplaceIgnoreCase">忽略大小写</el-checkbox>
        </el-form-item>
        <el-form-item label="匹配项">
          <span v-if="!tagReplaceMatchStats.valid" class="tag-replace-match-count tag-replace-match-count--muted">
            {{ tagReplaceMatchStats.message || '—' }}
          </span>
          <span v-else-if="tagReplaceMatchStats.remaining === 0" class="tag-replace-match-count tag-replace-match-count--none">
            无匹配项
          </span>
          <span v-else class="tag-replace-match-count">
            剩余 <strong>{{ tagReplaceMatchStats.remaining }}</strong> 处
            <template v-if="tagReplaceMatchStats.remaining < tagReplaceMatchStats.total">
              （共 {{ tagReplaceMatchStats.total }} 处）
            </template>
          </span>
        </el-form-item>
        <p class="tag-replace-tip">
          仅替换当前页指定范围内、可编辑的标签（第1条即列表最上方一项），只替换匹配的部分文字，不会自动保存。当前页共 {{ images.length }} 条。
          <template v-if="tagReplaceMode === 'regex'">正则示例：去数字 <code>\d+</code>，去空格 <code>\s+</code>，提取前缀 <code>^(.+?)-</code> 替换为 <code>$1</code></template>
          「替换（逐个）」每次只替换下一处匹配，可连续点击；「全部替换」一次替换范围内所有匹配。
          替换后会自动滚动到对应位置；勾选「自动跳转下一个」时还会定位到下一处待替换文字。「上一个」「下一个」可浏览匹配位置且不替换。
          完成后请点击「保存全部标签」保存。
        </p>
      </el-form>
      <div slot="footer" class="tag-replace-footer">
        <el-button @click="showTagReplaceDialog = false">取消</el-button>
        <el-button type="primary" plain @click="applyTagReplaceAll">全部替换</el-button>
        <span class="tag-replace-footer__one">
          <el-button plain @click="goTagReplacePrevious" :disabled="tagReplaceHistoryIndex <= 0">上一个</el-button>
          <el-button plain @click="goTagReplaceNext">下一个</el-button>
          <el-checkbox v-model="tagReplaceAutoJumpNext">自动跳转下一个</el-checkbox>
          <el-button type="primary" @click="applyTagReplaceOne">替换（逐个）</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ImageEdit from "./ImageEdit";
import ImageBox from "@/components/resources/ImageBox";
import SearchImageUpload from "@/components/resources/SearchImageUpload.vue";
import ImageDetail from "@/components/resources/ImageDetail.vue";
import ImageCompactGrid from "./ImageCompactGrid.vue";
import {openImagePreview} from "./imageMaterialUtils";
import {dateRangePickerOptions} from "@/base_js/dateRangePickerOptions";
import {mapState} from "vuex";

const IMAGE_MANAGE_VIEW_MODE_KEY = 'imageManage_viewMode'
const IMAGE_MANAGE_SEARCH_HISTORY_KEY = 'imageManage_searchHistory'
const IMAGE_MANAGE_SEARCH_HISTORY_MAX = 10

export default {
  name: "ImageManage",
  components: {
    SearchImageUpload,
    ImageEdit,
    ImageDetail,
    ImageBox,
    ImageCompactGrid
  },
  computed: {
    ...mapState("userOptions", ["userInfo"]),
    isMaterialCollaborator() {
      return this.userInfo && this.userInfo.accountType === "material_collaborator"
    },
    changedTagCount() {
      const that = this
      return this.images.filter(function (img) {
        return that.canEditToday(img.time) && (img.tag || '') !== (img._originalTag || '')
      }).length
    },
    pageSizeOptions() {
      return this.pageNumList.map(function (item) {
        return item.value
      })
    },
    showCurrentPageImageCount() {
      return this.images.length < this.pageCount
    },
    tagReplaceMatchStats: function () {
      if (!this.showTagReplaceDialog) {
        return { valid: false }
      }
      const config = this.buildTagReplaceConfig()
      if (config.error) {
        return { valid: false, message: config.error }
      }
      const range = this.parseTagReplaceRange(this.tagReplaceRange, this.images.length)
      if (range.error) {
        return { valid: false, message: range.error }
      }
      const that = this
      const state = this.tagReplaceOneState
      let remaining = 0
      let total = 0
      for (let i = 0; i < this.images.length; i++) {
        const rowNo = i + 1
        if (rowNo < range.start || rowNo > range.end) {
          continue
        }
        const img = this.images[i]
        if (!this.canEditToday(img.time)) {
          continue
        }
        const tag = img.tag || ""
        total += that.countMatchesInTagFromOffset(tag, config, 0)
        const offset = i === state.rowIndex ? state.charOffset : (i > state.rowIndex ? 0 : tag.length)
        if (i < state.rowIndex) {
          continue
        }
        remaining += that.countMatchesInTagFromOffset(tag, config, offset)
      }
      return { valid: true, remaining: remaining, total: total }
    }
  },
  watch: {
    tagReplaceFrom: function () {
      this.resetTagReplaceOneState()
    },
    tagReplaceTo: function () {
      this.resetTagReplaceOneState()
    },
    tagReplaceRange: function () {
      this.resetTagReplaceOneState()
    },
    tagReplaceMode: function () {
      this.resetTagReplaceOneState()
    },
    tagReplaceIgnoreCase: function () {
      this.resetTagReplaceOneState()
    }
  },
  data: function () {
    return {
      dialogTitle: "",//弹框标题
      isUpdate: false,//是否时修改图片
      selectImages: {},//当前是修改图片信息时可用
      requestNum: 0,//当前请求数量
      showLoading: false,//是否显示刷新界面
      showDialog: false,//是否显示弹框
      showDialogtoo: false,
      hasLoadImageBox: false,//是否开始加载数据
      images: [],//图片列表
      categoryList: [],//图片分类列表
      categoryId: null,
      sortStatus: {}, // 用于跟踪每列的排序状态
      hotOrderType: 0,//热度排序规则 0:不排序 1:升序 2:降序
      timeOrderType: 2,//上传时间排序规则 0:不排序 1:升序 2:降序
      updateTimeOrderType: 0,//更新时间排序规则 0:不排序 1:升序 2:降序
      hasTemplateDataOrderType: 0,//是否有操作数据排序 0:不排序 1:升序 2:降序
      hotnessOrder: 0,//新热度排序规则 0 不排序，1新热度升序，2新热度倒序，3最近7天热度升序，4最近7天热度倒序
      tagOrderType: 0,//标签排序 0:不排序 1:升序 2:降序；管理员功能，仅前端当前页排序，不增加后端复杂性以免影响APP
      searchName: "",//图片名称搜索关键字
      urlFileName: "",//url里的文件名
      urlFileNameSearching: false,//当前列表是否是文件名搜索结果，翻页继续走新接口
      searchHistory: [],//搜索历史，localStorage 持久化
      isStrictSearch: false,//是否严格匹配搜索
      pageNo: 1,//当前页面
      pageSum: 1,//总页码
      pageCount: 100,//每页显示数据量
      imageType: "all",//图片类别，有普通、搜索、自动模板类三种
      showImageDetailDialog: false,
      typeList: [{
        id: -1,
        label: '全部素材',
        value: "all",
      }, {
        id: 0,
        label: '普通',
        value: "",
      }, {
        id: 1,
        label: '搜索类',
        value: "search"
      }, {
        id: 2,
        label: '自动模板使用',
        value: "tpUse"
      }],
      pageNumList: [{
        id: 0,
        label: '每页50条',
        value: 50,
      }, {
        id: 1,
        label: '每页100条',
        value: 100
      }, {
        id: 2,
        label: '每页200条',
        value: 200
      }, {
        id: 3,
        label: '每页500条',
        value: 500
      }, {
        id: 4,
        label: '每页800条',
        value: 800
      }],
      dateRange: [],
      pickerOptions: dateRangePickerOptions,
      delImageIds: [],
      showTagReplaceDialog: false,
      tagReplaceMode: "normal",
      tagReplaceFrom: "",
      tagReplaceTo: "",
      tagReplaceIgnoreCase: false,
      tagReplaceRange: "",
      tagReplaceOneState: {
        rowIndex: 0,
        charOffset: 0
      },
      tagReplaceAutoJumpNext: true,
      tagReplacePositionHistory: [],
      tagReplaceHistoryIndex: -1,
      loadDialogData: false,
      selectcategory: [],
      priorityCategories: [], // 优先分类
      normalCategories: [], // 普通分类
      viewMode: localStorage.getItem(IMAGE_MANAGE_VIEW_MODE_KEY) || 'table',
      compactSortItems: [
        { prop: 'time', label: '上传时间' },
        { prop: 'heat', label: '热度' },
        { prop: 'hotness', label: '新热度' },
        { prop: 'tag', label: '标签' } // 管理员功能，前端本地排序，不走后端
      ]
    }
  },
  methods: {
    /**
     * 判断是否为视频文件
     * @param url 文件URL
     * @returns {boolean}
     */
    isVideoFile: function(url) {
      if (!url) return false;
      const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv', '.m4v'];
      return videoExtensions.some(ext => url.toLowerCase().includes(ext));
    },
    
    /**
     * 获取视频截图（阿里云OSS视频截帧）
     * @param videoUrl 视频URL
     * @returns {string}
     */
    getVideoSnapshot: function(videoUrl) {
      // 阿里云OSS视频截帧API，取第1秒的帧，jpg格式，80x80尺寸
      return videoUrl + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_80,h_80';
    },
    
    /**
     * 处理预览点击事件
     * @param event 点击事件
     * @param row 数据行
     */
    handlePreviewClick: function(event, row) {
      event.preventDefault();
      if (this.isVideoFile(row.url)) {
        this.showVideoDialog(row.url);
        return;
      }
      this.showImagePreviewDialog(row);
    },

    showImagePreviewDialog: function(row) {
      openImagePreview(row.url || '', row.tag || '图片预览');
    },
    
    /**
     * 显示视频播放弹窗
     * @param videoUrl 视频URL
     */
    showVideoDialog: function(videoUrl) {
      // 方案1：弹窗播放（如果有错误可注释掉）
      try {
        this.$alert('', '视频播放', {
          dangerouslyUseHTMLString: true,
          message: `<video controls style="width: 100%; max-width: 600px;" autoplay>
                      <source src="${videoUrl}" type="video/mp4">
                      您的浏览器不支持视频播放
                    </video>`,
          showConfirmButton: false,
          closeOnClickModal: true,
          customClass: 'video-dialog',
          callback: () => {}
        }).catch(() => {});
      } catch (error) {
        // 方案2：如果弹窗有问题，改用新窗口播放
        this.openVideoInNewWindow(videoUrl);
      }
    },
    
    /**
     * 在新窗口播放视频（备用方案）
     * @param videoUrl 视频URL
     */
    openVideoInNewWindow: function(videoUrl) {
      const newWindow = window.open('', '_blank', 'width=800,height=600');
      newWindow.document.write(`
        <html>
          <head><title>视频播放</title></head>
          <body style="margin:0; background:#000; display:flex; justify-content:center; align-items:center;">
            <video controls autoplay style="max-width:100%; max-height:100%;">
                <source src="${videoUrl}" type="video/mp4">
                您的浏览器不支持视频播放
            </video>
          </body>
        </html>
      `);
    },
    
    /**
     * 处理图片加载错误
     * @param event
     */
    handleImageError: function(event) {
      // 设置默认图标（视频播放图标）
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0zMiA1NlY0NEw0OCA1MEwzMiA1NloiIGZpbGw9IiM5OTk5OTkiLz4KPC9zdmc+';
    },
    
    canEditToday(timeValue) {
      if (!this.isMaterialCollaborator) {
        return true
      }
      return this.isToday(timeValue)
    },
    isToday(timeValue) {
      if (!timeValue) {
        return false
      }
      const parsedTime = this.parseMaterialTime(timeValue)
      if (parsedTime === null) {
        return false
      }
      const now = Date.now()
      const oneDayMs = 24 * 60 * 60 * 1000
      return parsedTime >= now || now - parsedTime <= oneDayMs
    },
    parseMaterialTime(timeValue) {
      if (timeValue instanceof Date) {
        const timestamp = timeValue.getTime()
        return Number.isNaN(timestamp) ? null : timestamp
      }

      if (typeof timeValue === 'number') {
        return timeValue < 1000000000000 ? timeValue * 1000 : timeValue
      }

      const normalizedValue = String(timeValue).trim()
      if (!normalizedValue) {
        return null
      }

      let parsedTime = Date.parse(normalizedValue)
      if (!Number.isNaN(parsedTime)) {
        return parsedTime
      }

      parsedTime = Date.parse(normalizedValue.replace(/-/g, '/'))
      return Number.isNaN(parsedTime) ? null : parsedTime
    },
    /**
     * 刷新前若有未保存标签更改，先让用户保存或放弃；关闭弹窗则不刷新
     * @returns {Promise<boolean>} true 表示可以继续刷新
     */
    confirmUnsavedTagsIfNeeded: function () {
      if (this.changedTagCount === 0) {
        return Promise.resolve(true)
      }
      if (this._unsavedTagConfirming) {
        return Promise.resolve(false)
      }
      this._unsavedTagConfirming = true
      const that = this
      return this.$confirm(
        '当前有 ' + this.changedTagCount + ' 个标签更改尚未保存。请先保存或放弃后再继续，否则列表不会刷新。',
        '未保存的标签更改',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: '保存',
          cancelButtonText: '放弃',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }
      ).then(function () {
        return that.saveAllImageTagsAsync().then(function (allOk) {
          return allOk
        })
      }).catch(function (action) {
        // 点「放弃」继续刷新；点关闭则不刷新
        return action === 'cancel'
      }).then(function (proceed) {
        that._unsavedTagConfirming = false
        return !!proceed
      })
    },
    /**
     * 获取当前图片列表（有未保存标签时会先确认）
     * @param {boolean|{force?: boolean}} [options] force=true 跳过确认直接刷新
     * @returns {Promise<boolean>} 是否已执行刷新
     */
    getImages: function (options) {
      const force = options === true || (options && options.force === true)
      const that = this
      if (force) {
        this.fetchCurrentImageList()
        return Promise.resolve(true)
      }
      return this.confirmUnsavedTagsIfNeeded().then(function (proceed) {
        if (proceed) {
          that.fetchCurrentImageList()
          return true
        }
        return false
      })
    },
    /**
     * 文件名搜索走新接口，其它情况仍走原来的列表接口
     */
    fetchCurrentImageList: function () {
      if (this.urlFileNameSearching) {
        this.fetchImageByFileName()
      } else {
        this.fetchImageList()
      }
    },
    /**
     * 按图片表 url 最后一段文件名搜索，不走原来的名称搜索接口
     */
    searchByFileName: function () {
      const name = (this.urlFileName || '').trim()
      if (!name) {
        this.$message.warning('请输入文件名')
        return
      }
      const prevPageNo = this.pageNo
      const wasSearching = this.urlFileNameSearching
      this.urlFileName = name
      this.urlFileNameSearching = true
      this.pageNo = 1
      const that = this
      this.getImages().then(function (refreshed) {
        if (!refreshed) {
          that.pageNo = prevPageNo
          that.urlFileNameSearching = wasSearching
        }
      })
    },
    fetchImageByFileName: function () {
      this.showLoading = true
      this.requestNum++
      const that = this
      const params = new URLSearchParams()
      params.append("fileName", this.urlFileName)
      params.append("pageNo", this.pageNo)
      params.append("pageCount", this.pageCount)
      params.append("isShowCategory", "1")
      this.$request.post("/images/searchImageByFileName", params)
          .then(function (data) {
            that.images = data.data.records
            that.snapshotImageTags(that.images)
            that.pageSum = data.data.pages
            that.requestNum--
            that.hideLoading()
          }).catch(function () {
        that.requestNum--
        that.hideLoading()
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        }).catch(function () {})
      })
    },
    /**
     * 实际请求图片列表
     */
    fetchImageList: function () {
      this.showLoading = true;
      this.requestNum++;
      const that = this;
      const params = new URLSearchParams()
      params.append("userId", "baozouptu")

      params.append("isPage", 1)
      params.append("pageNo", this.pageNo)
      params.append("pageCount", this.pageCount)
      params.append("isShowCategory", "1")
      if (this.categoryId === -999) {
        // 视频模板分类，使用hasTemplateData参数
        params.append("hasTemplateData", 10)
        params.append("categoryId", 0)
      } else if (this.categoryId !== null) {
        params.append("categoryId", this.categoryId)
      } else {
        params.append("categoryId", 0)
      }

      //图片种类
      params.append("category", this.imageType)

      params.append("heatOrder", this.hotOrderType)
      params.append("timeOrder", this.timeOrderType)
      params.append("updateTimeOrder", this.updateTimeOrderType)
      params.append("hasTemplateDataOrder", this.hasTemplateDataOrderType)
      params.append("hotnessOrder", this.hotnessOrder)
      params.append("searchName", this.searchName)
      params.append("isStrictSearch", this.isStrictSearch)
      if (this.dateRange && this.dateRange.length === 2) {
        const startDate = typeof this.dateRange[0] === 'string' ? new Date(this.dateRange[0]) : this.dateRange[0];
        const endDate = typeof this.dateRange[1] === 'string' ? new Date(this.dateRange[1]) : this.dateRange[1];
        
        const startTimeStr = startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate();
        const endTimeStr = endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate();
        
        params.append("startTime", startTimeStr);
        params.append("endTime", endTimeStr);
      }

      console.log("params = " + params)

      this.$request.post("/images/getImageList", params)
          .then(function (data) {
            that.images = data.data.records
            that.snapshotImageTags(that.images)
            if (that.tagOrderType > 0) {
              // 标签排序为前端本地排序，翻页后对新页数据重新应用
              that.sortImagesByTag()
            }
            that.pageSum = data.data.pages
            that.requestNum--;
            that.hideLoading()
          }).catch(function (err) {
        that.requestNum--;
        that.hideLoading()
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        }).catch(function () {})
      })
    },
    /**
     * 调接判断隐藏加载界面
     * */
    hideLoading: function () {
      if (this.requestNum <= 0) {
        this.showLoading = false
      }
    },
    /**
     * 分行设置类名
     * */
    tableRowClassName: function ({row, rowIndex}) {
      // if (rowIndex % 2 === 0) {
      //     return 'warning-row';
      // } else if (rowIndex % 2 !== 0) {
      //     return 'success-row';
      // }
      return '';
    },
    /**
     * 排序规则改变
     */
    sortChange: function ({column, prop, order}) {
      console.log(prop + " - " + order + " - " + this.sortStatus[prop])
      if (!this.sortStatus[prop]) {
        // 如果是第一次点击，设置为降序
        this.sortStatus[prop] = 'descending';
        column.order = 'descending';
      } else if (this.sortStatus[prop] === 'descending') {
        // 否则，根据当前排序状态更新
        this.sortStatus[prop] = 'ascending';
        column.order = 'ascending';
      } else {
        // 否则，根据当前排序状态更新
        this.sortStatus[prop] = 'descending';
        column.order = 'descending';
      }

      // 更新其他列的排序状态
      for (const key in this.sortStatus) {
        if (key !== prop) {
          this.sortStatus[key] = null;
        }
      }

      this.sortData(prop, this.sortStatus[prop]);
    },
    sortData(prop, order) {
      console.log("sortData排序状态：" + prop + " - " + order)
      // 标签排序：管理员功能，仅前端当前页排序，不增加后端复杂性以免影响APP
      if (prop === 'tag') {
        this.hotOrderType = 0
        this.timeOrderType = 0
        this.updateTimeOrderType = 0
        this.hasTemplateDataOrderType = 0
        this.hotnessOrder = 0
        this.tagOrderType = order === 'ascending' ? 1 : order === 'descending' ? 2 : 0
        this.sortImagesByTag()
        const orderText = this.tagOrderType === 1 ? '升序' : '降序'
        this.$message.info('已按标签' + orderText + '排序（当前页）')
        return
      }
      //初始化排序
      this.hotOrderType = 0;
      this.timeOrderType = 0;
      this.updateTimeOrderType = 0;
      this.hasTemplateDataOrderType = 0;
      this.hotnessOrder = 0;
      this.tagOrderType = 0;
      switch (prop) {
        case "heat":
          this.hotOrderType = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "time":
          this.timeOrderType = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "updateTime":
          this.updateTimeOrderType = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "hasTemplateData":
          this.hasTemplateDataOrderType = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "hotness":
          this.hotnessOrder = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "recentHotness":
          this.hotnessOrder = order === "ascending" ? 3 : order === "descending" ? 4 : 0;
          break
      }
      this.pageNo = 1;//重置页码
      this.urlFileNameSearching = false
      this.getImages()
    },
    // 标签排序：管理员功能，仅前端当前页排序，不增加后端复杂性以免影响APP
    sortImagesByTag: function () {
      if (!this.tagOrderType) return
      const factor = this.tagOrderType === 1 ? 1 : -1
      this.images.sort(function (a, b) {
        const tagA = (a.tag || '').trim()
        const tagB = (b.tag || '').trim()
        return factor * tagA.localeCompare(tagB, 'zh-CN')
      })
    },
    getCompactSortOrder: function (prop) {
      if (prop === 'time') {
        if (this.timeOrderType === 2) return 'descending'
        if (this.timeOrderType === 1) return 'ascending'
      }
      if (prop === 'heat') {
        if (this.hotOrderType === 2) return 'descending'
        if (this.hotOrderType === 1) return 'ascending'
      }
      if (prop === 'hotness') {
        if (this.hotnessOrder === 2) return 'descending'
        if (this.hotnessOrder === 1) return 'ascending'
      }
      if (prop === 'tag') {
        if (this.tagOrderType === 2) return 'descending'
        if (this.tagOrderType === 1) return 'ascending'
      }
      return null
    },
    onCompactSortClick: function (prop) {
      const currentOrder = this.getCompactSortOrder(prop)
      let nextOrder
      if (!currentOrder || currentOrder === 'ascending') {
        nextOrder = 'descending'
      } else {
        nextOrder = 'ascending'
      }
      this.sortStatus[prop] = nextOrder
      for (const key in this.sortStatus) {
        if (key !== prop) {
          this.sortStatus[key] = null
        }
      }
      this.sortData(prop, nextOrder)
    },
    getImageListRootEl: function () {
      if (this.viewMode === 'compact') {
        const compactGrid = this.$refs.compactGrid
        return compactGrid && compactGrid.$refs.gridRoot
      }
      const table = this.$refs.multipleTable
      return table && table.$el
    },
    onViewModeChange: function (mode) {
      localStorage.setItem(IMAGE_MANAGE_VIEW_MODE_KEY, mode)
      this.delImageIds = []
    },
    /**
     * 重置界面，清空所有搜索数据
     */
    reset: function () {
      // this.orderType = 0;
      this.searchName = ""
      this.urlFileName = ""
      this.urlFileNameSearching = false
      this.isStrictSearch = false;
      this.pageNo = 1;
      this.categoryId = null;
      this.getImages()
    },
    /**
     * 搜索功能
     * 清空当前分页情况
     */
    search: function (clearSort = false) {
      const prevPageNo = this.pageNo
      this.urlFileNameSearching = false
      this.pageNo = 1;
      if (clearSort) {
        this.sortStatus = {};
        this.hotOrderType = 0;
        this.timeOrderType = 0;
        this.updateTimeOrderType = 0;
        this.hasTemplateDataOrderType = 0;
        this.hotnessOrder = 0;
        this.tagOrderType = 0;
        if (this.$refs.multipleTable && typeof this.$refs.multipleTable.clearSort === 'function') {
          this.$refs.multipleTable.clearSort();
        }
      }
      this.saveSearchHistory(this.searchName)
      const that = this
      this.getImages().then(function (refreshed) {
        if (!refreshed) {
          that.pageNo = prevPageNo
        }
      })
    },
    // 搜索历史：管理员功能，localStorage 持久化，不增加后端复杂性以免影响APP
    loadSearchHistory: function () {
      try {
        const raw = localStorage.getItem(IMAGE_MANAGE_SEARCH_HISTORY_KEY)
        const list = raw ? JSON.parse(raw) : []
        this.searchHistory = Array.isArray(list) ? list.filter(function (item) {
          return typeof item === 'string' && item.trim()
        }).slice(0, IMAGE_MANAGE_SEARCH_HISTORY_MAX) : []
      } catch (e) {
        this.searchHistory = []
      }
      return this.searchHistory
    },
    saveSearchHistory: function (keyword) {
      const text = (keyword || '').trim()
      if (!text) return
      this.loadSearchHistory()
      const history = this.searchHistory.filter(function (item) {
        return item !== text
      })
      history.unshift(text)
      if (history.length > IMAGE_MANAGE_SEARCH_HISTORY_MAX) {
        history.length = IMAGE_MANAGE_SEARCH_HISTORY_MAX
      }
      this.searchHistory = history
      try {
        localStorage.setItem(IMAGE_MANAGE_SEARCH_HISTORY_KEY, JSON.stringify(history))
      } catch (e) {
        this.$message.warning('搜索历史保存失败，请检查浏览器是否允许本地存储')
      }
    },
    querySearchHistory: function (queryString, cb) {
      this.loadSearchHistory()
      const keyword = (queryString || '').trim()
      let results = this.searchHistory.map(function (item) {
        return { value: item }
      })
      if (keyword) {
        results = results.filter(function (item) {
          return item.value.indexOf(keyword) !== -1
        })
      }
      cb(results)
    },
    refreshSearchHistoryPanel: function () {
      const that = this
      this.loadSearchHistory()
      this.$nextTick(function () {
        const ac = that.$refs.searchAutocomplete
        if (!ac || typeof ac.getData !== 'function') {
          return
        }
        ac.getData(that.searchName || '')
        const input = ac.$refs.input
        if (input && typeof input.focus === 'function') {
          input.focus()
        }
      })
    },
    onSearchAutocompleteClick: function () {
      if ((this.searchName || '').trim()) {
        return
      }
      const ac = this.$refs.searchAutocomplete
      if (ac && ac.suggestionVisible) {
        return
      }
      this.refreshSearchHistoryPanel()
    },
    onSearchHistorySelect: function (item) {
      this.searchName = item.value
      this.search(true)
    },
    /**
     * 严格匹配开关变化事件
     */
    onStrictSearchChange: function () {
      if (this.searchName.trim() !== '') {
        this.pageNo = 1; // 重置页码
        this.getImages(); // 重新获取数据
      }
    },
    /**
     * 页码改变时
     * @param pageNo 改变的页码
     */
    changePage: function (pageNo) {
      const prevPageNo = this.pageNo
      if (pageNo === prevPageNo) {
        return
      }
      this.pageNo = pageNo
      const that = this
      this.getImages().then(function (refreshed) {
        if (!refreshed) {
          that.pageNo = prevPageNo
        }
      })
    },
    /**
     * 获取分类列表
     */
    getCategoryList: function () {
      this.requestNum++;
      this.showLoading = true;
      const that = this;
      const params = new URLSearchParams()
      params.append("isPage", 0)
      params.append("level", 1)
      this.$request.post("/imageCategory/getListByPage", params)
          .then(function (data) {
            // 处理数据结构，跳过一级分类，直接显示二级分类
            const result = that.processCategory(data.data)
            that.priorityCategories = result.priorityItems
            that.normalCategories = result.normalItems
            console.log('优先分类:', that.priorityCategories)
            console.log('普通分类:', that.normalCategories)
            that.requestNum--;
            that.hideLoading()
          }).catch(function (err) {
        that.requestNum--;
        that.hideLoading()
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        }).catch(function () {})
      })
    },

    /**
     * 处理分类数据，跳过一级分类直接显示二级分类
     */
    processCategory: function(rawData) {
      let processedData = [];
      let priorityItems = []; // 优先显示的项目
      let normalItems = []; // 普通项目
      
      if (rawData && rawData.length > 0) {
        // 遍历所有一级分类
        rawData.forEach(firstLevel => {
          if (firstLevel.childList && firstLevel.childList.length > 0) {
            // 遍历二级分类
            firstLevel.childList.forEach(secondLevel => {
              // 只处理三级分类
              if (secondLevel.childList && secondLevel.childList.length > 0) {
                secondLevel.childList.forEach(thirdLevel => {
                  const categoryName = secondLevel.categoryName + '-' + thirdLevel.categoryName;
                  const item = {
                    id: thirdLevel.id,
                    categoryName: categoryName,
                    level: 3
                  };
                  
                  // 判断是否为优先项目
                  if (categoryName === '贴图-表情' || 
                      (secondLevel.categoryName === '模板' && thirdLevel.categoryName === '默认')) {
                    priorityItems.push(item);
                  } else {
                    normalItems.push(item);
                  }
                });
              }
            });
          }
        });
      }
      
      // 优先项目排序：贴图-表情在前，模板-默认在后
      priorityItems.sort((a, b) => {
        if (a.categoryName === '贴图-表情') return -1;
        if (b.categoryName === '贴图-表情') return 1;
        return 0;
      });
      
      // 在其他分类中添加视频模板分类
      normalItems.push({
        id: -999, // 使用特殊ID标识这是视频模板分类
        categoryName: '模板-视频模板',
        level: 3,
        isVideoTemplate: true // 添加标识字段
      });
      
      // 合并数组：优先项目在前
      processedData = [...priorityItems, ...normalItems];
      
      return {
        priorityItems,
        normalItems
      };
    },

    /**
     * 分类选择改变时
     * @param value
     */
    selectCategoryChange: function (value) {
      console.log('选中分类:', value);
      this.categoryId = value;
      this.search(false);
    },

    /**
     * 选项选择时
     * @param data
     */
    selectChange: function (data) {
      console.log('selectChange:', data);
      if (data !== null) {
        this.categoryId = data;
      } else {
        this.categoryId = null;
      }
    },
    
    /**
     * 根据ID查找分类
     * @param id
     */
    findCategoryById: function(id) {
      const findInList = (list) => {
        for (let item of list) {
          if (item.id === id) {
            return item
          }
          if (item.childList && item.childList.length > 0) {
            const found = findInList(item.childList)
            if (found) return found
          }
        }
        return null
      }
      return findInList(this.categoryList)
    },

    /**
     * 添加一张图片
     */
    addImage: function () {
      this.dialogTitle = "添加图片信息"
      this.isUpdate = false
      this.selectImages = {
        heat: 4000,
        categoryId: 5,
        categoryIds: [1, 3, 5],
        isLock: 0,
        files: [],
        fileList: []
      }
      this.showDialog = true
    },
    /**
     * 重置为初次进入页面的状态，并按上传时间倒序刷新列表
     */
    resetToInitialState: function () {
      this.searchName = "";
      this.urlFileName = "";
      this.urlFileNameSearching = false;
      this.isStrictSearch = false;
      this.pageNo = 1;
      this.categoryId = null;
      this.dateRange = [];
      this.imageType = "all";
      this.sortStatus = {};
      this.hotOrderType = 0;
      this.timeOrderType = 2;
      this.updateTimeOrderType = 0;
      this.hasTemplateDataOrderType = 0;
      this.hotnessOrder = 0;
      this.tagOrderType = 0;
      this.delImageIds = [];
      this.$nextTick(() => {
        if (this.$refs.multipleTable && typeof this.$refs.multipleTable.clearSort === 'function') {
          this.$refs.multipleTable.clearSort();
        }
        this.getImages();
      });
    },
    snapshotImageTags: function (images) {
      const that = this
      images.forEach(function (img) {
        that.$set(img, '_originalTag', img.tag || '')
      })
    },
    openTagReplaceDialog: function () {
      this.tagReplaceMode = "normal"
      this.tagReplaceFrom = ""
      this.tagReplaceTo = ""
      this.tagReplaceIgnoreCase = false
      this.tagReplaceRange = this.images.length > 0 ? ("1-" + this.images.length) : "1-1"
      this.tagReplaceAutoJumpNext = true
      this.resetTagReplaceOneState()
      this.showTagReplaceDialog = true
    },
    resetTagReplaceOneState: function () {
      this.tagReplaceOneState = {
        rowIndex: 0,
        charOffset: 0
      }
      this.tagReplacePositionHistory = []
      this.tagReplaceHistoryIndex = -1
    },
    isSameTagReplaceVisit: function (a, b) {
      return a && b &&
        a.rowId === b.rowId &&
        a.matchStart === b.matchStart &&
        a.matchEnd === b.matchEnd
    },
    recordTagReplaceVisit: function (entry, options) {
      const opts = options || {}
      const shouldNavigate = opts.navigate !== false
      if (this.tagReplaceHistoryIndex < this.tagReplacePositionHistory.length - 1) {
        this.tagReplacePositionHistory = this.tagReplacePositionHistory.slice(0, this.tagReplaceHistoryIndex + 1)
      }
      const last = this.tagReplacePositionHistory[this.tagReplaceHistoryIndex]
      if (!this.isSameTagReplaceVisit(last, entry)) {
        this.tagReplacePositionHistory.push(entry)
        this.tagReplaceHistoryIndex = this.tagReplacePositionHistory.length - 1
      }
      if (shouldNavigate) {
        this.focusImageTagInput(entry.rowId, entry.matchStart, entry.matchEnd)
      }
    },
    goTagReplacePrevious: function () {
      if (this.tagReplaceHistoryIndex <= 0) {
        this.$message.info('已经是第一个位置')
        return
      }
      this.tagReplaceHistoryIndex--
      const entry = this.tagReplacePositionHistory[this.tagReplaceHistoryIndex]
      this.focusImageTagInput(entry.rowId, entry.matchStart, entry.matchEnd)
    },
    getTagReplaceBrowseSearchState: function () {
      const lastVisit = this.tagReplacePositionHistory[this.tagReplaceHistoryIndex]
      if (!lastVisit) {
        return this.tagReplaceOneState
      }
      const rowIndex = this.images.findIndex(function (img) {
        return img.id === lastVisit.rowId
      })
      if (rowIndex < 0) {
        return this.tagReplaceOneState
      }
      return {
        rowIndex: rowIndex,
        charOffset: lastVisit.matchEnd
      }
    },
    goTagReplaceNext: function () {
      if (this.tagReplaceHistoryIndex < this.tagReplacePositionHistory.length - 1) {
        this.tagReplaceHistoryIndex++
        const entry = this.tagReplacePositionHistory[this.tagReplaceHistoryIndex]
        this.focusImageTagInput(entry.rowId, entry.matchStart, entry.matchEnd)
        return
      }
      const config = this.buildTagReplaceConfig()
      if (config.error) {
        this.$message.warning(config.error)
        return
      }
      const range = this.parseTagReplaceRange(this.tagReplaceRange, this.images.length)
      if (range.error) {
        this.$message.warning(range.error)
        return
      }
      const target = this.findTagReplaceMatch(range, config, this.getTagReplaceBrowseSearchState())
      if (!target) {
        this.$message.info('指定范围内没有更多匹配')
        return
      }
      this.recordTagReplaceVisit({
        rowId: target.img.id,
        matchStart: target.match.start,
        matchEnd: target.match.end
      })
    },
    parseTagReplaceRange: function (rangeText, maxCount) {
      const text = (rangeText || "").trim()
      if (!text) {
        return { start: 1, end: maxCount }
      }
      if (maxCount <= 0) {
        return { error: "当前页没有可替换的数据" }
      }
      const rangeMatch = text.match(/^(\d+)\s*[-~～]\s*(\d+)$/)
      if (rangeMatch) {
        let start = parseInt(rangeMatch[1], 10)
        let end = parseInt(rangeMatch[2], 10)
        if (start > end) {
          const temp = start
          start = end
          end = temp
        }
        if (start < 1) {
          return { error: "起始条数不能小于 1" }
        }
        if (end > maxCount) {
          return { error: "结束条数不能大于当前页条数 " + maxCount }
        }
        return { start: start, end: end }
      }
      if (/^\d+$/.test(text)) {
        const rowNo = parseInt(text, 10)
        if (rowNo < 1 || rowNo > maxCount) {
          return { error: "条数需在 1-" + maxCount + " 之间" }
        }
        return { start: rowNo, end: rowNo }
      }
      return { error: "范围格式不正确，请输入如 1-100 或 1~50" }
    },
    buildTagReplaceConfig: function () {
      const from = this.tagReplaceFrom
      if (!from) {
        return { error: "请输入要查找的内容" }
      }
      if (from.length > 200) {
        return { error: "查找内容不能超过200个字符" }
      }
      const to = this.tagReplaceTo || ""
      if (this.tagReplaceMode === "normal") {
        return { mode: "normal", from: from, to: to }
      }
      let flags = "g"
      if (this.tagReplaceIgnoreCase) {
        flags += "i"
      }
      try {
        return { mode: "regex", pattern: new RegExp(from, flags), to: to }
      } catch (err) {
        return { error: "正则表达式无效：" + (err.message || "格式错误") }
      }
    },
    countTagReplaceMatches: function (tag, config) {
      return this.countMatchesInTagFromOffset(tag, config, 0)
    },
    countMatchesInTagFromOffset: function (tag, config, offset) {
      let count = 0
      let pos = offset
      while (pos <= tag.length) {
        const match = this.findFirstMatchInTag(tag, config, pos)
        if (!match) {
          break
        }
        count++
        pos = match.end
        if (match.start === match.end) {
          pos++
        }
      }
      return count
    },
    replaceTagText: function (tag, config) {
      if (config.mode === "normal") {
        if (tag.indexOf(config.from) === -1) {
          return tag
        }
        return tag.split(config.from).join(config.to)
      }
      return tag.replace(config.pattern, config.to)
    },
    findFirstMatchInTag: function (tag, config, offset) {
      const searchText = tag.substring(offset)
      if (!searchText) {
        return null
      }
      if (config.mode === "normal") {
        const idx = searchText.indexOf(config.from)
        if (idx === -1) {
          return null
        }
        return {
          start: offset + idx,
          end: offset + idx + config.from.length
        }
      }
      const flags = config.pattern.flags.replace("g", "")
      const pattern = new RegExp(config.pattern.source, flags)
      const match = pattern.exec(searchText)
      if (!match) {
        return null
      }
      return {
        start: offset + match.index,
        end: offset + match.index + match[0].length
      }
    },
    findTagReplaceMatch: function (range, config, state) {
      for (let i = state.rowIndex; i < this.images.length; i++) {
        const rowNo = i + 1
        if (rowNo < range.start || rowNo > range.end) {
          continue
        }
        const img = this.images[i]
        if (!this.canEditToday(img.time)) {
          continue
        }
        const tag = img.tag || ""
        const offset = i === state.rowIndex ? state.charOffset : 0
        const match = this.findFirstMatchInTag(tag, config, offset)
        if (!match) {
          continue
        }
        return {
          img: img,
          rowIndex: i,
          rowNo: rowNo,
          match: match
        }
      }
      return null
    },
    applyTagReplaceOne: function () {
      const config = this.buildTagReplaceConfig()
      if (config.error) {
        this.$message.warning(config.error)
        return
      }
      const range = this.parseTagReplaceRange(this.tagReplaceRange, this.images.length)
      if (range.error) {
        this.$message.warning(range.error)
        return
      }
      const that = this
      const target = this.findTagReplaceMatch(range, config, this.tagReplaceOneState)
      if (!target) {
        this.$message.info("指定范围内没有更多匹配")
        this.resetTagReplaceOneState()
        return
      }
      const tag = target.img.tag || ""
      const newTag = tag.substring(0, target.match.start) + config.to + tag.substring(target.match.end)
      if (newTag === tag) {
        this.$message.info("指定范围内没有更多匹配")
        this.resetTagReplaceOneState()
        return
      }
      this.$set(target.img, "tag", newTag)
      const nextOffset = (config.to || "").length > 0 ? target.match.start + config.to.length : target.match.end
      const nextState = {
        rowIndex: target.rowIndex,
        charOffset: nextOffset
      }
      this.tagReplaceOneState = nextState
      const replacedStart = target.match.start
      const replacedEnd = replacedStart + (config.to || '').length
      this.$nextTick(function () {
        that.recordTagReplaceVisit({
          rowId: target.img.id,
          matchStart: replacedStart,
          matchEnd: replacedEnd
        })
        if (that.tagReplaceAutoJumpNext) {
          requestAnimationFrame(function () {
            const nextTarget = that.findTagReplaceMatch(range, config, nextState)
            if (nextTarget) {
              that.recordTagReplaceVisit({
                rowId: nextTarget.img.id,
                matchStart: nextTarget.match.start,
                matchEnd: nextTarget.match.end
              })
            }
          })
        }
      })
      this.$message.success("已替换第 " + target.rowNo + " 条标签中的 1 处匹配，可继续点击「替换（逐个）」处理下一处")
    },
    applyTagReplaceAll: function () {
      const config = this.buildTagReplaceConfig()
      if (config.error) {
        this.$message.warning(config.error)
        return
      }
      const range = this.parseTagReplaceRange(this.tagReplaceRange, this.images.length)
      if (range.error) {
        this.$message.warning(range.error)
        return
      }
      const that = this
      let tagCount = 0
      let matchCount = 0
      this.images.forEach(function (img, index) {
        const rowNo = index + 1
        if (rowNo < range.start || rowNo > range.end) {
          return
        }
        if (!that.canEditToday(img.time)) {
          return
        }
        const tag = img.tag || ""
        const matches = that.countTagReplaceMatches(tag, config)
        if (matches === 0) {
          return
        }
        const newTag = that.replaceTagText(tag, config)
        if (newTag === tag) {
          return
        }
        that.$set(img, "tag", newTag)
        tagCount++
        matchCount += matches
      })
      if (tagCount === 0) {
        this.$message.info("指定范围内没有匹配的标签")
        return
      }
      this.resetTagReplaceOneState()
      this.showTagReplaceDialog = false
      this.$message.success("已更新 " + tagCount + " 个标签（第 " + range.start + "-" + range.end + " 条，共 " + matchCount + " 处匹配），请点击「保存全部标签」保存到服务器")
    },
    requestUpdateImageTag: function (selectImage) {
      if (selectImage.heat === undefined || selectImage.heat === "") {
        return Promise.reject(new Error("热度不能为空"))
      }
      const params = new FormData()
      params.append("id", selectImage.id)
      params.append("tag", selectImage.tag)
      params.append("isLock", selectImage.isLock)
      params.append("hot", selectImage.heat)
      params.append("categoryId", selectImage.categoryId)
      if (selectImage.file instanceof File) {
        params.append("file", selectImage.file)
      }
      if (selectImage.materialFile instanceof File) {
        params.append("materialImage", selectImage.materialFile)
      }
      if (selectImage.templateType !== undefined && selectImage.templateType !== "") {
        params.append("templateType", selectImage.templateType)
      }
      const that = this
      return this.$request.post("/images/updateImage", params).then(function (data) {
        if (data.status === 200) {
          that.$set(selectImage, '_originalTag', selectImage.tag || '')
          return data
        }
        return Promise.reject(new Error(data.message || '修改失败'))
      }).catch(function (err) {
        const msg = typeof err === 'string' ? err : (err && err.message ? err.message : '修改失败')
        return Promise.reject(new Error(msg))
      })
    },
    focusImageTagInput: function (rowId, selectionStart, selectionEnd) {
      const rowIndex = this.images.findIndex(function (img) {
        return img.id === rowId
      })
      if (rowIndex >= 0 && this.viewMode === 'compact') {
        const compactGrid = this.$refs.compactGrid
        if (compactGrid && compactGrid.ensureItemRendered) {
          compactGrid.ensureItemRendered(rowIndex)
        }
      }
      const that = this
      this.$nextTick(function () {
        requestAnimationFrame(function () {
          that.applyImageTagInputFocus(rowId, selectionStart, selectionEnd)
        })
      })
    },
    applyImageTagInputFocus: function (rowId, selectionStart, selectionEnd) {
      const rootEl = this.getImageListRootEl()
      if (!rootEl) {
        return false
      }
      const wrap = rootEl.querySelector('[data-tag-row-id="' + rowId + '"]')
      if (!wrap) {
        return false
      }
      const innerInput = wrap.querySelector('input:not([disabled]), textarea:not([disabled])')
      if (!innerInput) {
        return false
      }
      const scrollTarget = wrap.closest('.compact-card') || wrap.closest('tr.el-table__row') || wrap
      this.scrollTableRowIntoView(rowId)
      this.scrollPageToElement(scrollTarget)
      if (typeof scrollTarget.scrollIntoView === 'function') {
        scrollTarget.scrollIntoView({ block: 'center', behavior: 'smooth' })
      }
      innerInput.focus()
      const len = innerInput.value.length
      const start = selectionStart != null ? Math.min(Math.max(selectionStart, 0), len) : 0
      const end = selectionEnd != null ? Math.min(Math.max(selectionEnd, 0), len) : len
      innerInput.setSelectionRange(start, end)
      return true
    },
    scrollTableRowIntoView: function (rowId) {
      if (this.viewMode !== 'table') {
        return
      }
      const table = this.$refs.multipleTable
      if (!table || !table.bodyWrapper) {
        return
      }
      const rowIndex = this.images.findIndex(function (img) {
        return img.id === rowId
      })
      if (rowIndex < 0) {
        return
      }
      const bodyWrapper = table.bodyWrapper
      const rows = bodyWrapper.querySelectorAll('tbody tr.el-table__row')
      const rowEl = rows[rowIndex]
      if (!rowEl) {
        return
      }
      const rowTop = rowEl.offsetTop
      const rowBottom = rowTop + rowEl.offsetHeight
      const viewTop = bodyWrapper.scrollTop
      const viewBottom = viewTop + bodyWrapper.clientHeight
      const padding = 24
      if (rowTop < viewTop + padding) {
        bodyWrapper.scrollTop = Math.max(0, rowTop - padding)
      } else if (rowBottom > viewBottom - padding) {
        bodyWrapper.scrollTop = rowBottom - bodyWrapper.clientHeight + padding
      }
    },
    scrollPageToElement: function (el) {
      if (!el || typeof el.getBoundingClientRect !== 'function') {
        return
      }
      const padding = 24
      let node = el.parentElement
      while (node && node !== document.documentElement) {
        const style = window.getComputedStyle(node)
        const overflowY = style.overflowY
        if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
          const rect = el.getBoundingClientRect()
          const parentRect = node.getBoundingClientRect()
          if (rect.top < parentRect.top + padding) {
            node.scrollTop -= parentRect.top + padding - rect.top
          } else if (rect.bottom > parentRect.bottom - padding) {
            node.scrollTop += rect.bottom - parentRect.bottom + padding
          }
        }
        node = node.parentElement
      }
      const rect = el.getBoundingClientRect()
      const viewHeight = window.innerHeight || document.documentElement.clientHeight
      const margin = 120
      if (rect.top >= margin && rect.bottom <= viewHeight - margin) {
        return
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0
      const targetTop = scrollTop + rect.top - (viewHeight / 2) + (rect.height / 2)
      window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' })
    },
    handleTagInputKeydown: function (event, currentRow) {
      if (event.key !== 'Tab' && event.keyCode !== 9) {
        return
      }
      const currentIndex = this.images.indexOf(currentRow)
      if (currentIndex < 0) {
        return
      }
      const step = event.shiftKey ? -1 : 1
      let nextIndex = currentIndex + step
      const len = this.images.length
      while (nextIndex >= 0 && nextIndex < len) {
        const nextRow = this.images[nextIndex]
        if (this.canEditToday(nextRow.time)) {
          event.preventDefault()
          this.focusImageTagInput(nextRow.id)
          return
        }
        nextIndex += step
      }
    },
    /**
     * 更新图片标签
     * */
    updateImageTag: function (selectImage) {
      this.showLoading = true
      const that = this
      this.requestUpdateImageTag(selectImage).then(function () {
        that.showLoading = false
        that.$message.success('修改成功')
      }).catch(function (err) {
        that.showLoading = false
        that.showError(err.message)
      })
    },
    /**
     * 保存全部未提交的标签
     * @returns {Promise<boolean>} 是否全部保存成功
     */
    saveAllImageTagsAsync: function () {
      const that = this
      const changedImages = this.images.filter(function (img) {
        return that.canEditToday(img.time) && (img.tag || '') !== (img._originalTag || '')
      })
      if (changedImages.length === 0) {
        this.$message.info('没有需要保存的标签更改')
        return Promise.resolve(true)
      }
      this.showLoading = true
      const promises = changedImages.map(function (img) {
        return that.requestUpdateImageTag(img).then(function () {
          return { success: true }
        }).catch(function (err) {
          return { success: false, msg: err.message }
        })
      })
      return Promise.all(promises).then(function (results) {
        that.showLoading = false
        const successCount = results.filter(function (r) { return r.success }).length
        const failCount = results.length - successCount
        if (failCount === 0) {
          that.$message.success(`已保存 ${successCount} 个标签`)
          return true
        }
        if (successCount > 0) {
          that.$message.warning(`保存完成：成功 ${successCount} 个，失败 ${failCount} 个`)
        } else {
          const firstError = results.find(function (r) { return !r.success })
          that.showError(firstError ? firstError.msg : '保存失败')
        }
        return false
      })
    },
    saveAllImageTags: function () {
      this.saveAllImageTagsAsync()
    },
    /**
     * 查看图片详情
     * */
    showImageDetail: function (selectImages) {
      this.dialogTitle = "查看图片详情"
      this.isUpdate = true
      this.showDialog = true
      this.showImageDetailDialog = true

      selectImages.categoryIds = [selectImages.firstCategory.id, selectImages.secondCategory.id,
        selectImages.thirdCategory.id]

      selectImages.fileList = [{name: selectImages.tag, url: selectImages.url}]
      if (selectImages.materialImage !== null) {
        selectImages.materialList = [{name: selectImages.tag + "预览", url: selectImages.materialImage}]
      } else {
        selectImages.materialList = []
      }

      this.selectImages = selectImages
    },
    /**
     * 更新图片信息
     * */
    updateImage: function (selectImages) {
      this.dialogTitle = "添加修改素材信息"
      this.isUpdate = true
      this.showDialog = true

      selectImages.categoryIds = [selectImages.firstCategory.id, selectImages.secondCategory.id,
        selectImages.thirdCategory.id]

      selectImages.fileList = [{name: selectImages.tag, url: selectImages.url}]
      if (selectImages.materialImage !== null) {
        selectImages.materialList = [{name: selectImages.tag + "预览", url: selectImages.materialImage}]
      } else {
        selectImages.materialList = []
      }

      this.selectImages = selectImages
    },
    /**
     * 图片保存状态
     */
    saveStatus: function (flag) {
      if (flag === false) {
        this.showDialog = false
        return
      }
      if (this.isUpdate) {
        this.$notify({
          title: '保存成功',
          message: '图片已保存成功，请刷新页面查看更新结果',
          type: 'success',
          duration: 6000,
          position: 'top-right'
        })
      } else {
        this.resetToInitialState()
      }
      this.showDialog = false
    },

    /**
     * 弹框关闭时
     */

    closeDialog: function () {
      this.selectImages = {}
      this.loadDialogData = false;
      this.showImageDetailDialog = false;
    },
    /**
     * 删除某个图片
     * @param id 图片id
     */
    delImage: function (id) {
      this.$confirm('是否将图片移动到回收站?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: "messagebox-off-button-color",
        confirmButtonClass: "messagebox-ok-button-color"
      }).then(() => {
        this.del(id)
      }).catch(() => {
      });
    },
    /**
     * 单行点击，选中或者不选中
     */
    toggleSelection(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    /**
     * 多选回调
     * @param data 选中的对象数据
     */
    selectAllChange: function (data) {
      //清空数组
      this.delImageIds = new Array();
      //遍历选中的重新赋值
      data.forEach((item) => {
        this.delImageIds.push(item.id)
      })
    },
    /**
     * 发出删除一个图片请求
     * @param id
     */
    del: function (id) {
      this.requestNum++;
      this.showLoading = true;
      const that = this;
      const params = {
        "ids": [id],
        "state": 1 //1代表删除
      }
      this.$request.post("/images/updateState", params, {
        // json格式
        headers: {
          "Content-Type": "application/json"
        },
      })
          .then(function (data) {
            that.requestNum--;
            that.hideLoading()
            if (data.status === 200) {
              that.$message.success("删除成功");
              that.getImages()
            } else {
              that.showError(data.message)
            }
          }).catch(function (err) {
        that.requestNum--;
        that.hideLoading()
        that.showError("网络错误")
      })
    },
    /**
     * 删除多个图片
     */
    delImages: function () {
      this.$confirm('此操作将选中的文件批量移动到回收站, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: "messagebox-off-button-color",
        confirmButtonClass: "messagebox-ok-button-color"
      }).then(() => {
        this.delAll()
      }).catch(() => {
      });
    },
    /**
     * 删除选中的数据
     */
    delAll: function () {
      if (this.delImageIds === undefined || this.delImageIds.length === 0) {
        this.showError("请先选择要删除的图片");
        return;
      }

      this.showLoading = true;
      
      // 使用Promise.all并发处理所有删除请求
      const promises = this.delImageIds.map(id => {
        const params = {
          "ids": [id],
          "state": 1
        };
        return this.$request.post("/images/updateState", params, {
          headers: {
            "Content-Type": "application/json"
          },
        }).then(data => {
          return { success: data.status === 200, msg: data.message };
        }).catch(err => {
          return { success: false, msg: "网络错误" };
        });
      });

      Promise.all(promises).then(results => {
        this.showLoading = false;
        const successCount = results.filter(r => r.success).length;
        const failCount = results.length - successCount;
        
        if (successCount > 0) {
          let msg = `批量删除成功 ${successCount} 张`;
          if (failCount > 0) {
            msg += `，失败 ${failCount} 张`;
          }
          
          if (successCount === results.length) {
            this.$message.success(msg);
          } else {
            this.$message.warning(msg);
          }
          this.getImages();
          this.delImageIds = [];
        } else {
          this.showError("删除失败");
        }
      });
    },
    showError: function (msg) {
      this.$confirm(msg, "提示", {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: 'error'
      }).catch(function () {})
    },
    dialogOpen: function () {
      this.loadDialogData = true;
    },
    open: function () {
      this.showDialogtoo = true
    },
    postFrom: function (data) {
      console.log(data)
    },
    getCategory: function (name, categorys) {
      categorys.forEach(item => {
        let category = {}
        category.id = item.id
        category.categoryName = name + item.categoryName
        this.categoryList.push(category)
        if (item.childList !== null && item.childList !== undefined && item.childList.length > 0) {
          this.getCategory(category.categoryName + "/", item.childList)
        }
      })
    },
    // selectcategoryId:function (categoryList){
    //
    //   for (let i =0 ; i<categoryList.length;i++){
    //     if(categoryList[i].childList ===null)
    //       this.selectcategory.add(this.categoryList[i].id())
    //     return this.categoryList[i].id();
    //     return;
    //   }
    //   return
    /**
     * 日期范围改变时的回调
     */
    onDateRangeChange(value) {
      if (value && value.length === 2) {
        this.dateRange = value;
        this.search(false);
      }
    },
    onImageTypeChange(value) {
      this.imageType = value;
      this.search(false);
    },
    onPageCountChange(value) {
      this.pageCount = value;
      // 正在按文件名搜时，改每页条数继续走新接口，不要退回原来的名称搜索
      if (this.urlFileNameSearching) {
        this.pageNo = 1;
        this.getImages();
        return;
      }
      this.search(false);
    },
  },
  created: function () {
    this.loadSearchHistory()
  },
  mounted: function () {
    this.$bus.$emit("setMenuActiveIndex", "1-1-1");
    if (this.$route.query.searchName) {
      this.searchName = this.$route.query.searchName;
    }
    if (this.$route.query.isStrictSearch === 'true' || this.$route.query.isStrictSearch === true) {
      this.isStrictSearch = true;
    }
    this.getImages()

    this.getCategoryList()
    console.log(this.getCategoryList.categoryId)
  },

}
</script>

<style scoped>
.image_box {
  width: 100%;
  min-height: 100%;
  background: white;
  border-radius: 5px;
  padding: 10px 20px;
}

.box_operation {
  width: 100%;
  padding: 10px 0;
}

.first_row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.first_row_left {
  flex: 1;
  min-width: 0;
}

.file_name_search {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: 14px;
  margin-left: 8px;
}

.file_name_search /deep/ .el-input {
  width: 160px;
}

.file_name_search /deep/ .el-input__inner {
  color: #303133;
  border-color: #dcdfe6;
}

.file_name_search .el-button {
  margin-left: 2px;
  padding: 0 6px;
  color: #606266;
}

.input_box {
  display: inline-block;
  width: 140px;
  margin: 0 10px;
  margin-top: 10px;
}

.switch_box {
  width: 100px;
}

.input_box /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 90%;
  margin: 0 auto;
}

.btn_box {
  height: 40px;
  margin-top: 10px;
  margin: 10px;
  vertical-align: top;
  display: inline-block;
}

.input_box_select {
  width: 150px;
}

.data_box {
  width: 100%;

}

.view_mode_box {
  vertical-align: middle;
}

.compact-sort-bar {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 10px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 0 12px;
  min-height: 40px;
}

.compact-sort-title {
  flex-shrink: 0;
  padding: 0 16px 0 4px;
  font-size: 14px;
  color: #909399;
  user-select: none;
  border-right: 1px solid #ebeef5;
}

.compact-sort-item {
  display: inline-flex;
  align-items: center;
  padding: 0 20px;
  height: 40px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  user-select: none;
  border-right: 1px solid #ebeef5;
}

.compact-sort-item:last-child {
  border-right: none;
}

.compact-sort-item:hover {
  color: #409eff;
  background: #ecf5ff;
}

.compact-sort-item.is-active {
  color: #409eff;
  font-weight: 600;
}

.compact-sort-item i {
  margin-left: 4px;
}

.preview_container {
  position: relative;
  display: inline-block;
  /* 中灰双色棋盘：透明见格子，白色像素明显更亮；SVG 平铺性能友好 */
  background-color: #b0b0b0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cpath fill='%238a8a8a' d='M0 0h8v8H0zm8 8h8v8H8z'/%3E%3C/svg%3E");
  background-size: 12px 12px;
  background-repeat: repeat;
  border-radius: 2px;
  line-height: 0;
  overflow: hidden;
}

.preview_image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  display: block;
}

.video_mark {
  position: absolute;
  top: 2px;
  right: 2px;
  padding: 4px 6px;
  background: rgba(255, 200, 0, 0.9);
  color: black;
  font-size: 12px;
  font-weight: bold;
  border-radius: 4px;
  z-index: 10;
  line-height: 1;
}

.data_box /deep/ .el-table .warning-row {
  background: oldlace;
}

.data_box /deep/ .el-table .success-row {
  background: #f0f9eb;
}

.page {
  width: 100%;
  margin: 20px 0;
  text-align: center;
}

.page-count-tip {
  display: inline-block;
  margin-top: 12px;
  padding: 8px 18px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  background: #fdf6ec;
  border: 1px solid #f5dab1;
  border-radius: 4px;
  line-height: 1.4;
}

.page-count-tip__num {
  font-size: 20px;
  font-weight: 700;
  color: #e6a23c;
  margin: 0 4px;
}

.table {
  /*position: fixed;*/
  height: 100%;
}

/* 视频播放弹窗样式 */
/deep/ .video-dialog {
  max-width: 80%;
}

/deep/ .video-dialog .el-message-box__content {
  text-align: center;
}

/deep/ .video-dialog .el-message-box__message {
  margin: 0;
}

.date_range_box {
  width: 350px;
}

.date_range_box /deep/ .el-date-editor.el-input,
.date_range_box /deep/ .el-date-editor.el-input__inner {
  width: 100%;
}

.tag-replace-tip {
  margin: 0;
  color: #909399;
  font-size: 13px;
  line-height: 1.6;
}

.tag-replace-tip code {
  padding: 0 4px;
  background: #f4f4f5;
  border-radius: 3px;
  color: #606266;
}

.tag-replace-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.tag-replace-footer__one {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.tag-replace-match-count {
  font-size: 14px;
  color: #303133;
  line-height: 32px;
}

.tag-replace-match-count strong {
  color: #409eff;
  font-size: 16px;
}

.tag-replace-match-count--muted {
  color: #909399;
}

.tag-replace-match-count--none {
  color: #909399;
}

</style>
